import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SearchPagingResult } from '../shared/models/search-paging-result.model';

@Component({
  selector: 'feed-grid-pager',
  templateUrl: './feed-grid-pager.component.html',
  styleUrls: ['./feed-grid-pager.component.css']
})
export class FeedGridPagerComponent implements OnInit {
    @Input() top = false;
    @Input() bottom = false;
    @Input() pagingResults: SearchPagingResult = new SearchPagingResult();
    @Input() selectedPageSize: number;

    @Output() pageSizeChanged = new EventEmitter();
    @Output() pageChanged = new EventEmitter();


    pageSizes: number[] = [5, 10, 15, 25, 50, 100];

    constructor() { }

    ngOnInit() {
    }

    onPageSizeChanged(size: number) {
        this.pageSizeChanged.emit(size);
    }

    onPageChanged(startRow: number) {
        this.pageChanged.emit(startRow);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed-grid-pager/feed-grid-pager.component.ts